import * as React from 'react';
import { css } from '@emotion/core';
import Card from '../../../layout/card/Card';
import CardHeader from '../../../layout/card/CardHeader';
import { useMsgText } from '../../../localization/hooks';
import { Str } from '../../../localization/translationKeys';
import { faThermometerHalf } from '@fortawesome/free-solid-svg-icons';
import LocalSelect from '../../../localization/LocalSelect';
import { FLEX_COLUMN, FLEX_ROW } from '../../../layout/flexBox';
import { SELECT } from '../../../forms/styles/select';
import { DevPlanAction } from '../models';
import { COLORS } from '../../../globalStyle/colors';
import arrow from '../../../assets/triangle-down-white.svg';
import { onMobileDevice } from '../../../globalStyle/mediaQueries';
import { useActionStatus } from './hooks';
import LocalDiv from '../../../localization/LocalDiv';
import Msg from '../../../localization/Msg';


const styles = {
  root:                   [
    FLEX_COLUMN,
    css`
      padding: 15px;
      align-items: stretch;
    `,
  ],
  mobileRoot:             [
    FLEX_COLUMN,
    css`align-items: stretch;`,
  ],
  headerIcon:             css`
    font-size: 20px;
  `,
  select:                 [
    SELECT,
    css`
      margin: 10px;
      color: ${COLORS.WHITE};
      background-image: url(${arrow});
      user-select: none;
      font-size: 12px;
      
      ${onMobileDevice} { 
        margin: 0; 
      }
    `,
  ],
  collaboratorStatusView: [
    FLEX_ROW,
    css`
      align-items: center;
      background-image: none;

      &:hover {
        cursor: default;
      }
    `,
  ],
  dropDownOptions:        css`
    background-color: ${COLORS.WHITE};
  `,
};


type Props = {
  action: DevPlanAction;
  isParticipant: boolean;
  className?: string;
};


/**
 * StatusCard: a component that renders a drop-down for the user to change the action's status.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const StatusCard: React.FC<Props> = props => {
  const title = useMsgText(Str.Status);

  const { color, statuses, selected, onChange, loading } = useActionStatus(
    props.action.devItemId,
    props.action.devActionId,
    props.action.status,
  );

  return (
    <Card css={styles.root} className={props.className}>
      <CardHeader title={title} icon={faThermometerHalf} iconStyle={styles.headerIcon} />
      {
        props.isParticipant
          ? (
            <LocalSelect
              value={selected}
              onChange={onChange}
              disabled={loading}
              css={[styles.select, css`background-color: ${color};`]}
            >
              {
                statuses.map(status => (
                  <option
                    key={status.statusId}
                    value={status.statusId}
                    label={status.txt}
                    css={styles.dropDownOptions}
                  >{status.txt}</option>
                ))
              }
            </LocalSelect>
          ) : (
            <LocalDiv css={[styles.select, styles.collaboratorStatusView, css`background-color: ${color};`]}>
              <Msg str='' defaultMsg={statuses[selected].txt} />
            </LocalDiv>
          )
      }
    </Card>
  );
};

export default StatusCard;
